import { render, staticRenderFns } from "./dialog_newgood.vue?vue&type=template&id=d32cd00c&scoped=true&"
import script from "./dialog_newgood.vue?vue&type=script&lang=js&"
export * from "./dialog_newgood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32cd00c",
  null
  
)

export default component.exports